import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 当前位置 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-common-breadcrumb", { hide: _ctx.isHide }])
  }, [
    _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, { class: "cap" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeData, (item, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.path)
              ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: idx }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (!item.path)
              ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: idx }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _: 1
    })
  ], 2))
}